<igx-tabs tabAlignment="justify" style="width: 100%; height: 100%;">
  <igx-tab-item>
    <igx-tab-header>
      <span igxTabHeaderLabel>{{ 'MENSAJES.GRALS.DATOS_GENERALES' | translate }}</span>
    </igx-tab-header>
    <igx-tab-content>
      <div class="layout-box__el" igxFlex>
        <div class="layout-box" igxLayout style="padding-top: 5px; padding-bottom: 5px;">
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <label igxLabel>{{ 'MENSAJES.GRALS.EMPRESA' | translate }}:</label>
              <input #inputEmpresa igxInput name="Empresa" type="text" [(ngModel)]="registroSeleccionado.Empresa" uppercase [readOnly]="true"
                     (keydown)="stopPropagationPegado($event)"/>
            </igx-input-group>
          </div>
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <input #descripcionEmpresa igxInput [value]="registroSeleccionado.RazonSocialEmpresa"
                     id="descripcionEmpresa" name="descripcionEmpresa" [readonly]="true"/>
            </igx-input-group>
          </div>
        </div>
      </div>
      <div class="layout-box__el" igxFlex>
        <div class="layout-box" igxLayout style="padding-top: 5px; padding-bottom: 5px;">
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <label igxLabel>{{ 'MENSAJES.GRALS.CIUDAD' | translate }}:</label>
              <input #inputEmpresa igxInput name="Ciudad" type="text" [(ngModel)]="registroSeleccionado.Ciudad.Ciudad" uppercase [readOnly]="true"
                     (keydown)="stopPropagationPegado($event)"/>
            </igx-input-group>
          </div>
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <input #descripcionCiudad [value]="registroSeleccionado.Ciudad.DescripcionCiudad" igxInput
                     id="descripcionCiudad" name="descripcionCiudad" [readonly]="true"/>
            </igx-input-group>
          </div>
        </div>
      </div>
      <div class="layout-box__el" igxFlex>
        <div class="layout-box" igxLayout style="padding-top: 5px; padding-bottom: 5px;">
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <textarea #direccion igxInput [value]="registroSeleccionado.DireccionEmpresa" class="textArea"
                        id="direccion" name="direccion" [readonly]="true"></textarea>
              <label igxLabel for="direccion">{{ 'MENSAJES.GRALS.DIRECCION' | translate }}:</label>
            </igx-input-group>
          </div>
        </div>
      </div>
      <div class="layout-box__el" igxFlex>
        <div class="layout-box" igxLayout style="padding-top: 5px; padding-bottom: 5px;">
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <input #colonia igxInput [value]="registroSeleccionado.Colonia" id="coloniaObra" name="coloniaObra"
                     [readonly]="true" type="text"/>
              <label igxLabel for="coloniaObra">{{ 'MENSAJES.GRALS.COLONIA' | translate }}:</label>
            </igx-input-group>
          </div>
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <input #codigoPostal igxInput [value]="registroSeleccionado.CodigoPostalEmpresa" id="codigoPostal"
                     name="codigoPostal" [readonly]="true" type="text"/>
              <label igxLabel for="codigoPostal">{{ 'MENSAJES.GRALS.CODIGOPOSTAL' | translate }}:</label>
            </igx-input-group>
          </div>
        </div>
      </div>
      <div class="layout-box__el" igxFlex>
        <div class="layout-box" igxLayout style="padding-top: 5px; padding-bottom: 5px;">
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <input #telefono igxInput [value]="registroSeleccionado.TelefonoEmpresa" id="telefono" name="telefono"
                     type="number" [readonly]="true"/>
              <label igxLabel for="telefono">{{ 'MENSAJES.GRALS.TELEFONO' | translate }}:</label>
            </igx-input-group>
          </div>
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <input #mail igxInput [value]="registroSeleccionado.MailEmpresa" id="mail" name="mail" [readonly]="true"
                     type="text"/>
              <label igxLabel for="mail">{{ 'MENSAJES.GRALS.MAIL' | translate }}:</label>
            </igx-input-group>
          </div>
        </div>
      </div>
      <div class="layout-box__el" igxFlex>
        <div class="layout-box" igxLayout style="padding-top: 5px; padding-bottom: 5px;">
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <input #fax igxInput [value]="registroSeleccionado.FaxEmpresa" id="fax" name="fax" [readonly]="true"
                     type="text"/>
              <label igxLabel for="fax">FAX:</label>
            </igx-input-group>
          </div>
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <input #rfc igxInput [value]="registroSeleccionado.RfcEmpresa" id="rfc" name="rfc" [readonly]="true"
                     type="text"/>
              <label igxLabel for="rfc">RFC:</label>
            </igx-input-group>
          </div>
        </div>
      </div>
      <div class="layout-box__el" igxFlex>
        <div class="layout-box" igxLayout style="padding-top: 5px; padding-bottom: 5px;">
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <input #sitio igxInput [value]="registroSeleccionado.SitioWeb" type="url" id="sitio" name="sitio"
                     [readonly]="true"/>
              <label igxLabel for="sitio">{{ 'MENSAJES.GRALS.SITIO_WEB' | translate }}:</label>
              <igx-suffix style="padding-top: 6px">
                <app-btn-url-contenido [valor]="sitio.value"
                                       [archivoValido]="sitio.validity.valid"></app-btn-url-contenido>
              </igx-suffix>
            </igx-input-group>
          </div>
        </div>
      </div>
    </igx-tab-content>
  </igx-tab-item>
  <igx-tab-item>
    <igx-tab-header>
      <span igxTabHeaderLabel>{{ 'MENSAJES.GRALS.ADICIONALES' | translate }}</span>
    </igx-tab-header>
    <igx-tab-content>
      <div class="layout-box__el" igxFlex>
        <div class="layout-box" igxLayout style="padding-top: 5px; padding-bottom: 5px;">
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <label igxLabel>{{ 'MENSAJES.GRALS.RESPONSABLE' | translate }}:</label>
              <input #inputResponsable igxInput name="Responsable" type="text" [(ngModel)]="registroSeleccionado.Responsable.Responsable" uppercase [readOnly]="true"
                     (keydown)="stopPropagationPegado($event)"/>
            </igx-input-group>
          </div>
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <input #descripcionResp igxInput [value]="registroSeleccionado.Responsable.NombreResponsable"
                     id="descripcionResp" name="descripcionResp" [readonly]="true"/>
            </igx-input-group>
          </div>
        </div>
      </div>
      <div class="layout-box__el" igxFlex>
        <div class="layout-box" igxLayout style="padding-top: 5px; padding-bottom: 5px;">
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <input #cargoResp igxInput [value]="registroSeleccionado.Responsable.CargoResponsable" id="cargoResp"
                     name="cargoResp" type="text" readOnly="true"/>
              <label igxLabel for="cargoResp">{{ 'MENSAJES.GRALS.CARGORESP' | translate }}:</label>
            </igx-input-group>
          </div>
        </div>
      </div>
      <div class="layout-box__el" igxFlex>
        <div class="layout-box" igxLayout style="padding-top: 5px; padding-bottom: 5px;">
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <input #imss igxInput [value]="registroSeleccionado.IMSSEmpresa" id="imss" name="imss" [readonly]="true"
                     type="text"/>
              <label igxLabel for="imss">IMSS:</label>
            </igx-input-group>
          </div>
        </div>
      </div>

      <div class="layout-box__el" igxFlex>
        <div class="layout-box" igxLayout style="padding-top: 5px; padding-bottom: 5px;">
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <input #infonavit igxInput [value]="registroSeleccionado.InfonavitEmpresa" id="infonavit" name="infonavit"
                     [readonly]="true" type="text"/>
              <label igxLabel for="infonavit">INFONAVIT:</label>
            </igx-input-group>
          </div>
        </div>
      </div>

      <div class="layout-box__el" igxFlex>
        <div class="layout-box" igxLayout style="padding-top: 5px; padding-bottom: 5px;">
          <div class="layout-box__el" igxFlex>
            <igx-input-group>
              <input #cmic igxInput [value]="registroSeleccionado.CMICEmpresa" id="cmic" name="cmic" [readonly]="true"
                     type="text"/>
              <label igxLabel for="cmic">CMIC:</label>
            </igx-input-group>
          </div>
        </div>
      </div>
    </igx-tab-content>
  </igx-tab-item>
</igx-tabs>
